export enum SystemModule {
  None = 'NONE',
  ParkEval = 'PARK_EVAL',
  ParkAds = 'PARK_ADS'
}
